import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="variable-inserter"

export default class extends Controller {
  static targets = ["editor", "input", "inserter"]
  lastFocusedElement = null

  connect() {
    this.editorTargets.forEach((editor) => {
      editor.addEventListener("focus", () => {
        this.lastFocusedElement = { type: "editor", element: editor }
      })
    })
    this.inputTargets.forEach((input) => {
      input.addEventListener("focus", () => {
        this.lastFocusedElement = { type: "input", element: input }
      })
    })
  }

  insert(event) {
    event.preventDefault()
    const snippet = event.currentTarget.dataset.variableValue
    if (!this.lastFocusedElement) return

    const { type, element } = this.lastFocusedElement

    if (type === "editor") {
      element.focus()
      element.editor.insertString(snippet)
    } else if (type === "input") {
      this.insertIntoInput(element, snippet)
    }
  }

  insertLink(event) {
    event.preventDefault()
    const variableUrl = event.currentTarget.dataset.variableValue
    const linkText = event.currentTarget.dataset.linkText || "Link"

    if (!this.lastFocusedElement) return

    const { type, element } = this.lastFocusedElement

    if (type === "editor") {
      element.focus()
      const linkHtml = `<a href="${variableUrl}">${linkText}</a>`
      try {
        element.editor.insertHTML(linkHtml)
      } catch {
        element.editor.insertString(`[${linkText}](${variableUrl})`)
      }
    } else if (type === "input") {
      this.insertIntoInput(element, variableUrl)
    }
  }

  insertIntoInput(input, text) {
    const start = input.selectionStart
    const end = input.selectionEnd
    input.value = input.value.slice(0, start) + text + input.value.slice(end)
    input.focus()
    input.setSelectionRange(start + text.length, start + text.length)
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  updateInserterVisibility() {
    if (!this.hasInserterTarget) return

    const hasVisibleCustomizedSection = this.editorTargets.some((editor) => {
      const section = editor.closest("[data-mail-template-target]")
      if (section) {
        return !section.classList.contains("hidden")
      }
      return true
    })

    this.inserterTarget.classList.toggle("hidden", !hasVisibleCustomizedSection)
  }
}
